
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/var/www/baserow/baserow/web-frontend/sentry.client.config.ts")
            }
          });